import styled from '@emotion/styled';
import { SectionWrapper } from 'screens/DeveloperPage/styled';
import { NonMobilePopupContainer } from 'components/map/Preview/wrappers';
import { MAP_CONTROLS_DEFAULT_OFFSET } from 'components/map/Preview/wrappers';
import { COLLAPSED_CARD_HEIGHT } from 'screens/DeveloperPage/components/business-card/styled';
import { HEADER_HEIGHT } from 'ds/components/Layout';
import { DESKTOP_NAVIGATION_HEIGHT } from 'screens/DeveloperPage/components/navigation/styled';

export const Wrapper = styled(SectionWrapper)<{ showMobileMap: boolean; }>`
  position: relative;

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    max-height: 665px;
    height: calc(100vh - ${COLLAPSED_CARD_HEIGHT + HEADER_HEIGHT + DESKTOP_NAVIGATION_HEIGHT}px - ${theme.spacing(10)});
    margin-top: ${theme.spacing(5)};

    .map-satellite-toggle {
      position: absolute;
      z-index: 1;
    }
  `}
  ${({ theme, showMobileMap }) => theme.media.showAt({ to: 2 })`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;

    ${showMobileMap ? `
      opacity: 1;
      z-index: 10;
    ` : `
      opacity: 0;
      z-index: -1;
    `}
  `}
`;


export const MapWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  &, & .mapboxgl-map {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
  & .mapboxgl-ctrl-top-right, & .mapboxgl-ctrl.mapboxgl-ctrl-group {
    ${({ theme }) => theme.media.showAt({ to: 2 }) `
      top: ${MAP_CONTROLS_DEFAULT_OFFSET}px;
    `}
  }
  & .mapboxgl-ctrl.mapboxgl-ctrl-group {
    position: absolute;
    right: 14px;
    top: 14px;
  }
`;

const POPUP_SIZE = 214;
const POPUP_TRAIL_SIZE = 210;
const POPUP_TO_TRAIL_DISTANCE = 0;

const scaleFactor = POPUP_TRAIL_SIZE / POPUP_SIZE;
const commonScale = `scale3d(${scaleFactor}, ${scaleFactor}, ${scaleFactor})`;
const commonScaleSq = `scale3d(${scaleFactor ** 2}, ${scaleFactor ** 2}, ${scaleFactor ** 2})`;

export const PopupContainer = styled(NonMobilePopupContainer)`
  width: ${POPUP_SIZE}px;

  .mapboxgl-popup-anchor-right &,
  .mapboxgl-popup-anchor-bottom-right &,
  .mapboxgl-popup-anchor-top-right & {
    &:before {
      transform: translate3d(${-POPUP_TO_TRAIL_DISTANCE}px, 0, 0) ${commonScale};
      transform-origin: left;
    }
    &:after {
      transform: translate3d(${-POPUP_TO_TRAIL_DISTANCE * 2}px, 0, 0) ${commonScaleSq};
      transform-origin: left;
    }
  }
  .mapboxgl-popup-anchor-left &,
  .mapboxgl-popup-anchor-bottom-left &,
  .mapboxgl-popup-anchor-top-left & {
    &:before {
      transform: translate3d(${POPUP_TO_TRAIL_DISTANCE}px, 0, 0) ${commonScale};
      transform-origin: right;
    }
    &:after {
      transform: translate3d(${POPUP_TO_TRAIL_DISTANCE * 2}px, 0, 0) ${commonScaleSq};
      transform-origin: right;
    }
  }
  .mapboxgl-popup-anchor-bottom & {
    &:before {
      transform: translate3d(0, ${-POPUP_TO_TRAIL_DISTANCE}px, 0) ${commonScale};
      transform-origin: top;
    }
    &:after {
      transform: translate3d(0, ${-POPUP_TO_TRAIL_DISTANCE * 2}px, 0) ${commonScaleSq};
      transform-origin: top;
    }
  }
  .mapboxgl-popup-anchor-top & {
    &:before {
      transform: translate3d(0, ${POPUP_TO_TRAIL_DISTANCE}px, 0) ${commonScale};
      transform-origin: bottom;
    }
    &:after {
      transform: translate3d(0, ${POPUP_TO_TRAIL_DISTANCE * 2}px, 0) ${commonScaleSq};
      transform-origin: bottom;
    }
  }
`;

export const CardWrapper = styled.div`
  ${({ theme }) => `
    background: ${theme.colors.neutrals.white};
  `}
`;
